import * as React from 'react';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { UIComponentState } from '../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { GridComponent, GridComponentProps } from '../../../toolkit/grid/gridcomponent';
import { TabViewModelImpl } from '../../../toolkit/tabs/tab/tabviewmodel';
import { FeaturedCategoryListCSSStyle, FeaturedCategoryListCSSStyleImpl } from './list/featuredcategorylistcss';
import { ListViewModel } from '../../../toolkit/horizontallist/listviewmodel';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import './featured-titles-style.css';

export class FeaturedCategoryTabViewModelImpl extends TabViewModelImpl
{
    private ref: GridComponent<GridComponentProps<ToneDto>, UIComponentState>;
    private cssStyle: FeaturedCategoryListCSSStyle;
    private isShowMore: boolean = false;
  
    constructor(private context: BaseContext, private title: string, 
        private listViewModel: ListViewModel<ToneDto>, private showMore: any, private showLess: any)
    {
        super();

        this.cssStyle = new FeaturedCategoryListCSSStyleImpl(context);
    }

    getTitle(): string 
    {
        return this.title;
    }

    getTabView(): JSX.Element
    {  
        return (
         <>
          <div id="featured-titles-wrapper">
                                {
                                    this.getWebView()
                                }
                    </div>
                {/* <div id="featured-titles-col-wrapper">
                                {
                                    this.getMobileView()
                                }
                </div> */}
            <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.listViewModel} context={this.context}/>
         </>);

    }

    getWebView()
    {
        return (
            <>
            <div id="featured-category-main-div" style={{}}>
                <div id="featured-category-title-div" style={{}}>
                <label id="featured-category-title-label" style={this.cssStyle.getTitleCSSStyle()}>{this.title}</label>
                </div>
                {this.isShowMore && <div  style={{flex: 0.5, textAlign: "right", justifyContent: "flex-end"}}>
                    <label id="featured-category-showmore-label" onClick={this.showMore} style={this.cssStyle.getShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_more)}</label>
                </div>}
                {!this.isShowMore && <div  style={{flex: 0.5, textAlign: "right", justifyContent: "flex-end"}}>
                    <label id="featured-category-showmore-label" onClick={this.showLess} style={this.cssStyle.getShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_less)}</label>
                </div>}
            </div>
            </>
        );
    }

    getMobileView()
    {
        return (
            <>
            <div style={{display: "flex", flexFlow: "row wrap", width: "100%"}}>
                <div style={{flex: 0.8, textAlign: "left", justifyContent: "flex-start"}}>
                <label style={this.cssStyle.getMobileTitleCSSStyle()}>{this.title}</label>
                </div>
                {this.isShowMore && <div style={{flex: 0.5, textAlign: "right", justifyContent: "flex-end"}}>
                    <label onClick={this.showMore} style={this.cssStyle.getMobileShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_more)}</label>
                </div>}
                {!this.isShowMore && <div style={{flex: 0.5, textAlign: "right", justifyContent: "flex-end"}}>
                    <label onClick={this.showLess} style={this.cssStyle.getMobileShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_less)}</label>
                </div>}
            </div>
            </>
        );
    }
    
    updateTabData(listOfDatas: ToneDto[], isShowMore: boolean, scrollToPosition: number, isScrollToPositionRequired: boolean)
    {
        this.isShowMore = isShowMore;
        // this.listViewModel.getListOfDatas().length = 0;
        this.listViewModel.setListDatas(listOfDatas);
        this.listViewModel.setScrollToPosition(scrollToPosition,isScrollToPositionRequired);
        this.ref !== null && this.ref !== undefined && this.ref.forceUpdateComponent();
    }

    deleteData(id: string)
    {
        this.listViewModel.deleteData(id);

        this.ref !== null && this.ref.forceUpdateComponent();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/featuredcategorytabviewmodel.tsx